import React, { useState, useEffect } from "react";
import { Modal, Table, Tooltip } from "antd";
import MediaFetcher from "../library/MediaFetcher";
import moment from "moment";
import { useAssignAdUnits } from "../hooks/assignAdUnits";
import { modal as modalTokens } from "../../Tasks/configs/designTokens";

const EditDisplayAdUnitsModal = ({
  open,
  onClose,
  orgMedias,
  adGroupId,
  initialSelected,
  onSubmit,
  title = "Edit Ad Units",
}) => {
  const [selectedIds, setSelectedIds] = useState(initialSelected || []);
  const { handleAssignAdUnits, assigning } = useAssignAdUnits(onSubmit);

  useEffect(() => {
    setSelectedIds(initialSelected || []);
  }, [initialSelected, open]);

  const filteredOrgMedias = orgMedias
    ? orgMedias.filter(media => !initialSelected.includes(media.id))
    : [];

  const rowSelection = {
    selectedRowKeys: selectedIds,
    onChange: setSelectedIds,
    columnWidth: 32,
  };

  const handleOk = async () => {
    await handleAssignAdUnits([adGroupId], selectedIds);
    if (onSubmit) {
      await onSubmit();
    }
    setSelectedIds([]);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      confirmLoading={assigning}
      title={title}
      width={modalTokens.wide}
      className="creative-adgroup-modal"
    >
      <div className="creative-detail-card__table-scroll creative-table">
        <Table
          rowKey="id"
          size="middle"
          rowSelection={rowSelection}
          dataSource={filteredOrgMedias}
          columns={[
            {
              title: "",
              dataIndex: "key",
              key: "key",
              width: "100px",
              align: "left",
              render: key => (
                <MediaFetcher
                  mediaKey={key}
                  className="creative-detail-card__media-thumb-lg"
                />
              ),
            },
            {
              title: "Ad Unit Name",
              dataIndex: "name",
              key: "name",
              align: "left",
              sorter: (a, b) => a.name.localeCompare(b.name),
              render: text => (
                text && text.length > 20 ? (
                  <Tooltip title={text}>
                    <span>{text.slice(0, 46).concat("...")}</span>
                  </Tooltip>
                ) : (
                  <span>{text}</span>
                )
              ),
            },
            {
              title: "Aspect",
              dataIndex: "aspect",
              key: "aspect",
              width: "15%",
              align: "left",
              sorter: (a, b) => a.width - b.width || a.height - b.height,
              render: (_, record) =>
                record.width && record.height
                  ? `${record.width}x${record.height}`
                  : "—",
            },
            {
              title: "Hi-Res",
              dataIndex: "ResProp",
              key: "ResProp",
              width: "10%",
              align: "left",
              sorter: (a, b) => (a.ResProp || "").localeCompare(b.ResProp || ""),
            },
            {
              title: "File Type",
              dataIndex: "fileType",
              key: "fileType",
              width: "10%",
              align: "left",
              sorter: (a, b) => a.fileType.localeCompare(b.fileType),
            },
            {
              title: "Date Uploaded",
              dataIndex: "createdAt",
              key: "createdAt",
              width: "20%",
              align: "left",
              sorter: (a, b) =>
                moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf(),
              render: d =>
                d ? moment(d).format("MM/DD/YYYY hh:mm A") : "—",
            },
          ]}
        />
      </div>
    </Modal>
  );
};

export default EditDisplayAdUnitsModal;
